import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Card, Image as SemanticImage } from 'semantic-ui-react';
import Button from "@mui/material/Button";
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import md5 from 'md5';
import AspectsList from 'app/components/AspectsList';

import UploadFile from 'app/components/UploadFile';
import classes from 'app/components/Modal/classes.module.scss';

import {
  getProductOverlays,
  createProductOverlays,
  uploadProductAsset,
  deleteProductOverlay,
  deleteOverlayAspect
} from 'app/actions/jobConfigs';

import {
  updateMoment
} from 'app/services/moments';

const OverlayList = (props) => {
  const { isOpen, onClose, getProductOverlays, selectedJobConfig, createProductOverlays,
    uploadProductAsset, deleteProductOverlay, deleteOverlayAspect } = props;

  const [overlays, setOverLays] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isAspectDialogVisible, setIsAspectDialogVisible] = useState(false);

  let boxClass = classes.paper,
    boxStyle = { maxWidth: "960px" },
    headerVariant = 'h5';

  useEffect(() => {
    if (!loaded) {
      getProductOverlays(selectedJobConfig.product_id).then((results) => {
        const _result = Object.assign([], results);
        _result.splice(0, 0, { id: 0 });
        setOverLays(_result);
        setLoaded(true);
      })
    }
  }, [loaded])

  useEffect(() => {
    if (isOpen) {
      setLoaded(false);
    }
  }, [isOpen])

  const loadedAspects = async (id) => {
    const overlays = await getProductOverlays(selectedJobConfig.product_id)
    const selectedOverlay = overlays.find(o => o.id === id);
    if (selectedOverlay) {
      return selectedOverlay.aspects;
    }
    return [];
  }

  const handleOverlayChanged = async (event, overlayId) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (file) {
        const hashCallback = function (hash) {
          file.hash = hash;
          const dimensionCallback = function (file) {
            const jsonFile = Object.assign({}, file);
            jsonFile.name = file.name;
            jsonFile.type = file.type;
            jsonFile.size = file.size;
            createProductOverlays(selectedJobConfig.product_id, [jsonFile], overlayId).then(async (result) => {
              for (var overlay of result.aspects) {
                if (overlay.hash == file.hash) {
                  await uploadProductAsset(overlay.moment_id, file.type, file);
                  await updateMoment(overlay.moment_id, { id: overlay.moment_id, uploaded: new Date().toISOString() });
                }
              }
              alert('Overlay uploaded successfully');
              setLoaded(false);
              return Promise.resolve();
            })
          }
          getImageDimension(file, dimensionCallback);
        }
        createHash(file, hashCallback);
      }
    }
  }

  const getImageDimension = (file, callback) => {
    var image = new Image();
    image.onload = function () {
      file.width = image.width;
      file.height = image.height;
      callback(file);
    }
    image.src = URL.createObjectURL(file);
  }

  const createHash = (file, callback) => {
    var fr = new FileReader();

    fr.onload = function () {
      return callback(md5(fr.result));
    }

    fr.readAsBinaryString(file);
  }

  const handleDelete = async (id) => {
    const deleteMsg = "Are you sure you want to remove this overlay? It will be removed from this product";
    if (window.confirm(deleteMsg) === true) {
      await deleteProductOverlay(selectedJobConfig.product_id, id).then(() => {
        setLoaded(false);
      })
    }
  }

  const handleViewAspects = (overlay) => {
    setSelectedItem(overlay);
    setIsAspectDialogVisible(true);
  }

  return <div>
    <Modal open={isOpen} className={classes.modal} onClose={onClose}>
      <Box className={boxClass} style={boxStyle}>
        <CloseIcon className={classes.closeIcon} onClick={onClose} />
        <Typography variant={headerVariant} className={classes.formTitle}>
          Manage Overlays
        </Typography>
        <hr />
        <Card.Group>
          {
            overlays && overlays.map((o, index) => {
              if (o.id === 0) {
                return <Card key={index}>
                  <Card.Content>
                    <div className={classes.upload}>
                      <UploadFile onFileChange={(e) => { handleOverlayChanged(e, 0) }} />
                    </div>
                  </Card.Content>
                </Card>
              }

              return <Card key={index}>
                <Card.Content>
                  <SemanticImage src={o.url} wrapped ui={true} />
                </Card.Content>
                <Card.Content extra textAlign='center'>
                  <Button fullWidth variant="contained" onClick={() => { handleViewAspects(o) }}>View Aspects</Button>
                </Card.Content>
                <Card.Content extra>
                  <div className='ui two buttons'>
                    <Button fullWidth variant="contained" component="label">
                      <input
                        type="file"
                        accept={props.acceptedTypes || 'image/*'}
                        hidden
                        onChange={(e) => handleOverlayChanged(e, o.id)}
                      />
                      Add Size</Button>
                    <Button fullWidth variant="contained" onClick={() => handleDelete(o.id)}>Remove</Button>
                  </div>
                </Card.Content>
              </Card>
            })
          }
        </Card.Group>
      </Box>
    </Modal>
    {
      isAspectDialogVisible &&
      <AspectsList isOpen={true}
        onClose={() => { setIsAspectDialogVisible(false); }}
        title='Overlay Aspects'
        type='overlay'
        getData={loadedAspects} selectedItem={selectedItem}
        addSize={handleOverlayChanged}
        jobConfig={selectedJobConfig}
        onDelete={deleteOverlayAspect}
      />
    }
  </div>
}

const mapStateToProps = state => ({
  darkMode: state.portalReducer.darkMode,
  user: state.userReducer.user
});

export default connect(mapStateToProps, { uploadProductAsset, getProductOverlays, createProductOverlays, deleteProductOverlay, deleteOverlayAspect })(OverlayList);
